import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { APP } from 'garaje/utils/enums';
let RoomDisplayNameInput = (_class = class RoomDisplayNameInput extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "graphql", _descriptor, this);
    _initializerDefineProperty(this, "roombaMetrics", _descriptor2, this);
    _initializerDefineProperty(this, "inputValue", _descriptor3, this);
    _initializerDefineProperty(this, "showErrorOnEdit", _descriptor4, this);
    _initializerDefineProperty(this, "showSuccessOnEdit", _descriptor5, this);
    _defineProperty(this, "editRoomDisplayNameTask", _buildTask(() => ({
      context: this,
      generator: function* (displayName) {
        this.showErrorOnEdit = false;
        this.showSuccessOnEdit = false;
        try {
          yield this.graphql.updateRoomConfig({
            id: this.args.room.id,
            displayName
          });
          this.showSuccessOnEdit = true;
        } catch (error) {
          this.showErrorOnEdit = true;
        }
        this.roombaMetrics.trackEvent('room_display_name_changed', {
          roomDisplayName: displayName,
          room_id: this.args.room.id,
          product: APP.ROOMS,
          company_id: this.args.room.companyId
        });
        yield this.args.onDisplayNameChanged();
      }
    }), {
      restartable: true
    }, "editRoomDisplayNameTask", null));
  }
  focusInput(element) {
    if (!this.args.shouldAutofocusInput || !element) {
      return;
    }
    element && element.focus();
  }
  async onSubmitDisplayName(event) {
    const value = event.target && 'value' in event.target ? event.target['value'] : null;
    const isKeyUp = 'type' in event && event.type == 'keyup';
    const isButtonClick = 'type' in event && event.type == 'click';
    if (isKeyUp && value) {
      this.inputValue = value;
    }
    if ('code' in event && event.code != 'Enter' && !isButtonClick) {
      return;
    }
    await this.editRoomDisplayNameTask.perform(this.inputValue);
  }
  get isDisplayNameChanged() {
    return this.args.room.name != this.args.room.displayName;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "roombaMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "inputValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showErrorOnEdit", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showSuccessOnEdit", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "focusInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSubmitDisplayName", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmitDisplayName"), _class.prototype)), _class);
export { RoomDisplayNameInput as default };